function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDice = function SvgDice(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 2885.6277 2704.1771",
    ref: svgRef
  }, props), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "10133,15467 10129,14256 11185,14856 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "10136,14251 11011,14009 11184,14851 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "11018,14028 11437,14845 11184,14851 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "10118,14006 10994,14010 10129,14256 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "10115,14013 9587,14826 10130,14257 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "10131,14260 9563,14856 10133,15472 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "10132,15481 9586,14890 10116,15694 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "11185,14856 11002,15690 10133,15472 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "11185,14856 11437,14845 11010,15672 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("polygon", {
    style: {
      fill: "#373435",
      stroke: "#fefefe",
      strokeWidth: 7.61999989
    },
    points: "10115,15694 10132,15472 10989,15687 ",
    transform: "translate(-9057.7735,-13501.24)"
  }), React.createElement("text", {
    x: 239.2092,
    y: 2116.834,
    style: {
      fontWeight: "normal",
      fontSize: "580.11999512px",
      fontFamily: "Arial",
      fill: "#fefefe"
    },
    transform: "rotate(-29.999471)"
  }, "20"));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dice.34c4a176.svg";
export { ForwardRef as ReactComponent };